import {MenuItemLink, UserMenu as BaseUserMenu} from 'react-admin';
import LogoutIcon from '@material-ui/icons/LockOpen';
import { forwardRef } from "react";
import { useAuth0 } from '@auth0/auth0-react';

const LogoutButton = forwardRef(({ onClick }, ref) => {
  const {logout} = useAuth0();

  return (
    <MenuItemLink
      ref={ref}
      to=""
      primaryText="Logout"
      leftIcon={<LogoutIcon />}
      onClick={() => {
        onClick && onClick();

        logout({returnTo: window.location.origin});

      }}
    />
  )
});

const UserMenu = props => (
  <BaseUserMenu {...props} logout={<LogoutButton />} />
);

export default UserMenu
